module.exports = __webpack_public_path__ + "img/9cf6e9c5ce76dcd53be61219d72e29a6.png";